import { BranchesOutlined } from "@ant-design/icons";

import appdev from "../../assets/appdev.svg";

export default function getMenuItem(orgName) {
  return {
    id: 1.2,
    title: "App Deployments",
    description: "Standalone unstructured data apps",
    icon: BranchesOutlined,
    image: appdev,
    path: `/${orgName}/app`,
    active: window.location.pathname.startsWith(`/${orgName}/app`),
  };
}
